import { useCallback } from 'react'
import { emit } from '../../platform/analytics/analytics'
import { Panel } from '../../platform/primitives/Panel'
import { BackLink } from '../../platform/primitives/BackLink'
import { ARTICLES } from './articles'
import { useOnce } from '../../platform/analytics/useOnce'
import './help.css'

/**
 * One article. An unknown slug is not the app 404: the chrome already says
 * Help & support, and the way back is one link away.
 */
export function HelpArticle({ slug }: { slug: string }) {
  const index = ARTICLES.findIndex((a) => a.slug === slug)
  const article = ARTICLES[index]

  useOnce(
    useCallback(() => {
      if (index >= 0) emit('help_article_opened', { item_index: index })
    }, [index]),
  )

  return (
    <article className="help help--article">
      <Panel className="help__section">
      {article ? (
        <>
          <h2 className="help__h">{article.title}</h2>
          {article.body.map((p) => (
            <p key={p} className="help__p">
              {p}
            </p>
          ))}
        </>
      ) : (
        <p className="help__p">That article doesn&apos;t exist.</p>
      )}
      </Panel>
      <BackLink to="/help">All help articles</BackLink>
    </article>
  )
}
